import { apiRoutes } from '../apiRoutes';
import axiosAuth from '../utils/axiosAuth';

export const getDispatches = async ({ queryKey }) => {
  const [, page, pageSize] = queryKey;
  return await axiosAuth.get(
    `${apiRoutes.d2dApi}?page=${page}&pageSize=${pageSize}`
  );
};

export const getSubDistricts = async () => {
  return await axiosAuth.get(`${apiRoutes.subDistricts}?page=1&pageSize=300`);
};

export const getPreviousExecutionInfo = async () => {
  return await axiosAuth.get(`${apiRoutes.rundeck}/LastExecution`);
};

export const getNextExecutionTime = async () => {
  return await axiosAuth.get(`${apiRoutes.rundeck}/NextExecution`);
};

// Boundary scope is applied server-side from the auth token; no org segments.
export const getFacilityByOrgUnit = async () => {
  return await axiosAuth.get(`${apiRoutes.facilities}`);
};

// Admin-only: update a facility's editable attributes. Authorized server-side
// (admin role + the facility must be within the caller's OrgUnit boundary).
export const updateFacility = async ({ id, pepfar, expectedToReport }) => {
  return await axiosAuth.put(`${apiRoutes.facilities}/${id}`, {
    pepfar,
    expectedToReport
  });
};

// Admin-only: rebase a facility's DQA history so a corrected dispatch can be
// re-evaluated from scratch. Authorized + boundary-guarded server-side.
export const resetFacilityDqa = async ({ id, reason }) => {
  return await axiosAuth.post(`${apiRoutes.facilities}/${id}/dqa-reset`, {
    reason
  });
};

export const getFacilityDetails = async ({ queryKey }) => {
  const [, facilityId] = queryKey;
  return await axiosAuth.get(
    `${apiRoutes.manifest}/Facility/${facilityId}?historyPageSize=1000`
  );
};

// Boundary scope is applied server-side from the auth token; no org segments.
export const getDashboardSummary = async () => {
  return await axiosAuth.get(`${apiRoutes.dashboard}/Summary`);
};

export const getReportingPerformance = async ({ queryKey }) => {
  const [, start_date, end_date] = queryKey;
  return await axiosAuth.get(
    `${apiRoutes.dashboard}/Performance/${start_date}/${end_date}`
  );
};

export const getOwnerNotifications = async ({ queryKey }) => {
  const [, ownerId] = queryKey;
  return await axiosAuth.get(
    `${apiRoutes.dashboard}/Notifications/Owner/${ownerId}?page=1&pageSize=1000`
  );
};

export const getNotificationById = async ({ queryKey }) => {
  const [, id] = queryKey;
  return await axiosAuth.get(`${apiRoutes.dashboard}/Notification/${id}`);
};

export const notificationAcknowledged = async (values) => {
  // Remove token from values if present (it's now handled automatically)
  // eslint-disable-next-line no-unused-vars
  const { token, ...payload } = values;
  return await axiosAuth.post(
    `${apiRoutes.dashboard}/Notification/Acknowledged`,
    payload
  );
};

// Boundary scope is applied server-side from the auth token; no org segments.
export const getMostRecentFacilityDispatchTable = async () => {
  return await axiosAuth.get(
    `${apiRoutes.manifest}/Facility/Latest?page=1&pageSize=5000`
  );
};

export const getTxCurrByReportingDate = async ({ queryKey }) => {
  const [, reportingDate] = queryKey;
  return await axiosAuth.get(
    `${apiRoutes.txCurr}?reportingDate=${reportingDate}&page=1&pageSize=100000`
  );
};
